module.exports = __webpack_public_path__ + "img/logos.2db5857f.png";